// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flight-plus-hotel-form-content {\n  padding: 10px;\n  display: grid;\n  height: calc(100vh - 64px);\n}\n.flight-plus-hotel-form {\n  grid-column-start: content-start;\n  grid-column-end: content-end;\n}\n.flight-plus-hotel-saved-offers-header {\n  padding-top: 50px;\n}\n.flight-plus-hotel-form-submit {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
